import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { reduxForm } from 'redux-form';

import { Modal } from 'semantic-ui-react';
import { ModalTemplate, ReduxFormMaterialTextField, TagColor, Button } from 'components';

import { tagNameAsyncValidate } from 'libs/validation';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalTagAdd extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { visible, isClicked, onAddTag, onToggleModal, color, onCheckColorAdd } = this.props;
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-tagAdd-area', 'common-content')}
        visible={visible}
        onToggleModal={onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalTagAdd_1', defaultMessage: '태그 만들기' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_3', defaultMessage: '취 소' }))}
            </Button>
            <Button className={cx('brand-button')} disabled={isClicked} loading={isClicked} onClick={onAddTag}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_2', defaultMessage: '생 성' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <div className={cx('tagName-wrapper')}>
            <div className={cx('inputName-title')}>
              {defineMessages(formatMessage({ id: 'ModalTagAdd_4', defaultMessage: '태그명' }))}
            </div>
            {/* <span className={cx('tagAdd-title')}>태그명</span> */}
            <ReduxFormMaterialTextField
              // label={defineMessages(formatMessage({ id: 'ModalTagAdd_4', defaultMessage: '태그명*' }))}
              className={cx('input-area')}
              name="tagName"
              checkType={101}
              validate={['required', 'tagName']}
            />
          </div>
          <div className={cx('color-area')}>
            {/* <span className={cx('tagAdd-title')}>색상</span> */}
            <TagColor color={color} onCheckColor={onCheckColorAdd} />
          </div>
        </div>
      </ModalTemplate>
    );
  }
}
ModalTagAdd.propTypes = {
  visible: PropTypes.bool,
  onAddTag: PropTypes.func,
  onToggleModal: PropTypes.func
};

export default reduxForm({
  form: 'formTagAdd',
  enableReinitialize: true,
  asyncValidate: tagNameAsyncValidate,
  asyncBlurFields: ['tagName'],
  destroyOnUnmount: false,
  touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
})(injectIntl(ModalTagAdd));



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalTagAdd.js